import React, { useState, useEffect } from 'react';

// 📅⌨️ Data + hora DIGITÁVEIS — substitui o <input datetime-local>, cujo
// seletor de hora (lista rolante) é péssimo de usar. A hora aqui é um campo
// de texto: digitou "1430" vira "14:30" sozinho.
// value no MESMO formato do datetime-local ('YYYY-MM-DDTHH:MM'), então a
// troca é plug-and-play; incompleto emite '' (as validações existentes pegam).
export default function CampoDataHora({ value, onChange, style }) {
  const [d, setD] = useState('');
  const [h, setH] = useState('');

  useEffect(() => {
    const atual = d && /^\d{2}:\d{2}$/.test(h) ? `${d}T${h}` : '';
    if ((value || '') !== atual && value) {
      const [vd, vh] = String(value).split('T');
      setD(vd || '');
      setH((vh || '').slice(0, 5));
    }
    // value vazio não apaga o que o usuário está digitando
  }, [value]); // eslint-disable-line

  function emitir(d2, h2) {
    setD(d2); setH(h2);
    onChange(d2 && /^\d{2}:\d{2}$/.test(h2) ? `${d2}T${h2}` : '');
  }
  function mudarHora(v) {
    let t = v.replace(/[^0-9:]/g, '').slice(0, 5);
    if (/^\d{3,4}$/.test(t)) t = t.slice(0, 2) + ':' + t.slice(2); // 1430 → 14:30
    emitir(d, t);
  }

  const base = { padding: '7px 9px', border: '1px solid #c8d0da', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' };
  return (
    <div style={{ display: 'flex', gap: 6, ...(style?.width === '100%' ? { width: '100%' } : {}) }}>
      <input type="date" value={d} onChange={e => emitir(e.target.value, h)}
        style={{ ...base, ...style, width: undefined, flex: 1, marginBottom: undefined }} />
      <input type="text" value={h} placeholder="HH:MM" maxLength={5} inputMode="numeric"
        onChange={e => mudarHora(e.target.value)}
        title="Digite a hora — ex.: 1430 vira 14:30"
        style={{ ...base, ...style, width: 74, flex: 'none', textAlign: 'center', marginBottom: undefined }} />
    </div>
  );
}
